module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/000-c417a9618a723c0649a06c6d219a77a3.png";